/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { TMarkOnboardingAsViewedModel, IMappers, TMarkOnboardingAsViewedResponse } from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { ISaveUserOnboardingResponse } from '../../entities/onboardings/SaveUserOnboardingResponse';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createMarkOnboardingAsViewedModel(): TMarkOnboardingAsViewedModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'price-estimator',
    pathApi: '/v1/mark-onboarding-as-viewed/',
    response: {
      '200': {
        contentType: 'json',
      },
      '400': {
        contentType: 'json',
      },
    },
  };
}

export interface IMarkOnboardingAsViewedOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

export async function fetchMarkOnboardingAsViewed<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
}: IMarkOnboardingAsViewedOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TMarkOnboardingAsViewedResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createMarkOnboardingAsViewedModel(),
    config,
  )) as FetchResponse<TMarkOnboardingAsViewedResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as ISaveUserOnboardingResponse, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TMarkOnboardingAsViewedResponse>;
}
